import service from './index'

const prefix = '/audit/log-record';

export interface AuditListRequest {
  pageNum?: number;
  pageSize?: number;
  operationTypes?: string[];
  globalFlag?: boolean;
  startDate?: string;
  endDate?: string;
  filterField?: string | null;
  sortByField?: string | null;
  arithmeticSymbol?: string;
  fieldValue?: string;
  sortBy?: string;
  globalFieldSearch?: string | null;
  [key: string]: any;
}

// ACL
export const fetchAuditList = (params: AuditListRequest) => service.post(`${prefix}/list`, params);

export const fetchAuditFieldModification = (auditId: string) => service.get(prefix + `/one/modification-info?auditId=${auditId}`);

export const fetchOperationListByEntityId = (params: any) => service.post(prefix + `/entity/operation-list`, params);
export const postSaveAuditLog = (params: any) => service.post(prefix + '/audit-log', params);

export const EXPORT_AUDIT_LOG_URL = `${prefix}/export`;

export const EXPORT_NEW_AUDIT_LOG_URL = `${prefix}/export/all/elegant`;

export const EXPORT_AUDIT_ENTITY_IDENTIFIER_URL = `${prefix}/export/entity/operation-list/v2`

export const EXPORT_AUDIT_FIELD_MODIFICATION_URL = `${prefix}/export/one/modification-info`